define([
    '../Util/freezeObject'
], function (
    freezeObject) {
    'use strict'

    /**
     * 态势标绘编辑状态。
     *
     * @exports EnumPlottingStatus
     * 
     * @see Plotting#status
     */
    var EnumPlottingStatus = {
        /**
         * 浏览。
         * @type {String}
         * @constant
         */
        SHOW: "SHOW",

        /**
         * 创建。
         * @type {String}
         * @constant
         */
        CREATE: "CREATE",

        /**
         * 编辑。
         * @type {String}
         * @constant
         */
        EDIT: "EDIT"
    }
    freezeObject(EnumPlottingStatus)
    /**
    * 反向查找对齐方式的名称。
    * 
    * @param {String} value 对齐方式的数值。
    * @returns {String} 对齐方式的名称。
    */
    function getName(value) {
        for (var key in EnumPlottingStatus) {
            if (EnumPlottingStatus.hasOwnProperty(key) && EnumPlottingStatus[key] === value) {
                return key
            }
        }
        return undefined
    }
    return {
        SHOW: "SHOW",
        CREATE: "CREATE",
        EDIT: "EDIT",
        getName: getName
    }
})